function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg056Malaysia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 192,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 320,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 448,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 64
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M142.964,176.883c-26.997,0-48.883-21.886-48.883-48.883s21.886-48.883,48.883-48.883   c8.418,0,16.337,2.128,23.253,5.876c-10.848-10.607-25.682-17.155-42.053-17.155C90.937,67.838,64,94.773,64,128   s26.937,60.162,60.162,60.162c16.371,0,31.206-6.548,42.053-17.155C159.301,174.753,151.381,176.883,142.964,176.883z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "156.738,93.621 165.416,111.77 185.016,107.241 176.238,125.34 192,137.839    172.376,142.263 172.432,162.379 156.738,149.794 141.044,162.379 141.098,142.263 121.474,137.839 137.236,125.34    128.459,107.241 148.058,111.77  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg056Malaysia);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHJlY3QgeT0iNjQiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSIxOTIiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSIzMjAiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB5PSI0NDgiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjY0Ii8+CjwvZz4KPHJlY3Qgc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2Ii8+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0xNDIuOTY0LDE3Ni44ODNjLTI2Ljk5NywwLTQ4Ljg4My0yMS44ODYtNDguODgzLTQ4Ljg4M3MyMS44ODYtNDguODgzLDQ4Ljg4My00OC44ODMgICBjOC40MTgsMCwxNi4zMzcsMi4xMjgsMjMuMjUzLDUuODc2Yy0xMC44NDgtMTAuNjA3LTI1LjY4Mi0xNy4xNTUtNDIuMDUzLTE3LjE1NUM5MC45MzcsNjcuODM4LDY0LDk0Ljc3Myw2NCwxMjggICBzMjYuOTM3LDYwLjE2Miw2MC4xNjIsNjAuMTYyYzE2LjM3MSwwLDMxLjIwNi02LjU0OCw0Mi4wNTMtMTcuMTU1QzE1OS4zMDEsMTc0Ljc1MywxNTEuMzgxLDE3Ni44ODMsMTQyLjk2NCwxNzYuODgzeiIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMTU2LjczOCw5My42MjEgMTY1LjQxNiwxMTEuNzcgMTg1LjAxNiwxMDcuMjQxIDE3Ni4yMzgsMTI1LjM0IDE5MiwxMzcuODM5ICAgIDE3Mi4zNzYsMTQyLjI2MyAxNzIuNDMyLDE2Mi4zNzkgMTU2LjczOCwxNDkuNzk0IDE0MS4wNDQsMTYyLjM3OSAxNDEuMDk4LDE0Mi4yNjMgMTIxLjQ3NCwxMzcuODM5IDEzNy4yMzYsMTI1LjM0ICAgIDEyOC40NTksMTA3LjI0MSAxNDguMDU4LDExMS43NyAgIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };